import React from 'react';
import { MainContent } from '../../utilities/mainContent';
import TableData from '../../utilities/table';
import {
  Grid,
  IconButton,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Typography,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import { MenuButtons } from '../../utilities/menuButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { DialogBox } from '../../utilities/dialog';
import { DeleteContent } from '../../../hooks/utils';
import { Add } from './add';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import AssetService from '../../../service/asset';
import { usePerms } from '../../../hooks/usePerms';

const items = [
  {
    label: 'Edit Category',
    icon: <EditIcon fontSize='small' />,
  },
  {
    label: 'Delete Category',
    icon: <DeleteIcon fontSize='small' />,
  },
];

const itemAdmin = [
  {
    label: 'Edit Category',
    icon: <EditIcon fontSize='small' />,
  },
];

const csvCol = [
  {
    key: 'name',
    label: 'Category Name',
  },

  {
    key: 'createdAt',
    label: 'CreatedAt',
  },
  {
    key: 'updatedAt',
    label: 'UpdatedAt',
  },
];

export const CategoryComponent = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isDialog, setIsDialog] = React.useState(false);
  const [setMobileOpens, setMobileOpenss] = React.useState(false);
  const [category, setCategory] = React.useState(null);
  const [filtered, setFiltered] = React.useState(null);
  const [isDelete, setIsDelete] = React.useState(false);
  const queryClient = useQueryClient();
  const entryRole = ['admin'];
  const entryRole2 = ['user'];
  const { role } = usePerms('', entryRole);
  const { role: userRole } = usePerms('', entryRole2);

  const itemCheck = role ? itemAdmin : items;

  const { data, isLoading } = useQuery({
    queryKey: ['assetCategories'],
    queryFn: () => AssetService.allAssetLabel('category'),
  });
  const { mutate } = useMutation({
    mutationFn: AssetService.AssetLabel,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['assetCategories'] });
      setIsDelete(false);
    },
  });
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const toggleDrawer = () => {
    setMobileOpenss(!setMobileOpens);
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Category Name',
      width: 580,
    },

    {
      field: 'createdAt',
      headerName: 'CreatedAt',
      width: 250,
    },
    {
      field: 'updatedAt',
      headerName: 'UpdatedAt',
      width: 240,
    },

    {
      field: '',
      headerName: '',
      width: 20,
      renderCell: (params) => {
        return (
          <Grid container justifyContent='flex-end'>
            <IconButton
              aria-controls={open ? 'fade-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              disabled={userRole ? true : false}
            >
              <MoreVertIcon />
            </IconButton>
            <MenuButtons
              anchorEl={anchorEl}
              open={open}
              handleClose={handleClose}
              items={itemCheck.map((item, index) => (
                <MenuItem
                  key={index}
                  onClick={() => handleMenuItem(item, params)}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText>
                    <Typography variant='subtitle2'>{item.label}</Typography>
                  </ListItemText>
                </MenuItem>
              ))}
            />
          </Grid>
        );
      },
    },
  ];

  const handleMenuItem = (item, params) => {
    if (item.label === 'Category') {
      toggleDrawer();
      setAnchorEl(null);
    } else if (item.label === 'Edit Category') {
      setAnchorEl(null);
      setIsDialog(() => true);
    } else if (item.label === 'Delete Category') {
      setAnchorEl(null);
      setIsDelete(() => true);
    } else {
      return null;
    }
  };
  return (
    <>
      <MainContent
        csvData={data}
        csvHeaders={csvCol}
        csvDataWithFilter={filtered || data}
        csvHeadersWithFilter={csvCol}
        fileNameWithFilter={'Assert Category list'}
        fileName={'Assert Category list'}
        onChangeSearch={(val) => {
          const searchVal = val?.target?.value || '';
          if (!searchVal) {
            setFiltered(() => data);
            return;
          }
          const value = (data || []).filter(
            (item) => item?.name?.toLowerCase().indexOf(searchVal.toLowerCase()) > -1
          );
          setFiltered(() => value);
        }}
        valueFrom='add_assetcategory'
        isBtnName={true}
        btnName={'Add'}
        onBtnNameClick={() => {
          setCategory(null);
          setIsDialog(true);
        }}
        items={
          <TableData
            cols={columns}
            rows={filtered ? filtered : data}
            height='400px'
            isLoading={isLoading}
            onRowClick={({ row }) => setCategory(() => row)}
          />
        }
      />
      <DialogBox
        handleClose={() => setIsDialog(false)}
        open={isDialog}
        title={
          <Typography variant='subtitle1' component='span'>
            Asset Category
          </Typography>
        }
        content={
          <Add
            label_name='Category'
            handleClose={() => setIsDialog(false)}
            category={category}
            mutationFn={
              category ? AssetService.AssetLabel : AssetService.addAssetLabel
            }
          />
        }
      />
      <DialogBox
        handleClose={() => setIsDelete(false)}
        open={isDelete}
        maxWidth='500px'
        title={
          <Typography variant='subtitle1' component='span'>
            Delete Asset Category
          </Typography>
        }
        content={
          <DeleteContent
            title='Are you sure you want to delete this asset category ?'
            onCancel={() => setIsDelete(false)}
            onSubmit={() => {
              const id = category.id;
              const method = 'delete';
              const label = 'category';
              mutate({ id, method, label });
            }}
          />
        }
      />
    </>
  );
};
